<template>
    <div class="wrap">
        <h1>비밀번호 찾기</h1>
        <div class="find-pw">
            <h2>비밀번호 재설정</h2>
            <p class="guide">※ 여러 사이트에 동일한 비밀번호를 사용하면 도용되기 쉬우므로<br>비밀번호를 주기적으로 변경해 주는 것이 안전합니다.</p>
            <ul>
                <li><input type="password" id="new-password" v-model="pass" placeholder="새 비밀번호"></li>
                <li>
                    <input type="password" id="new-password2" v-model="pass_re" placeholder="새 비밀번호 확인">
                    <p class="pw-notice">* 8~32자의 영문 대문자, 소문자, 숫자, 특수문자 조합</p>
                </li>
            </ul>
            <p class="btn-ok"><button type="button" @click="onSubmit">확인</button></p>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'step2',
    data () {
      return {
        pass: '',
        pass_re: '',
      }
    },
    methods: {
      onSubmit() {
        if (!this.pass) return alert('패스워드는 공백으로 설정할수 없습니다.')
        if (this.pass != this.pass_re) return alert('새 비밀번호 확인 패스워드가 동일하지 않습니다.')
        this.$emit('onSubmit', this.pass)
      }
    }
  }
</script>

<style scoped>
    .wrap {
        width: 100%;
        height: 100vh;
        padding: 50px 0;
        background-color: #f5f6fa;
    }

    .wrap h1 {
        color: #474747;
        text-align: center;
        letter-spacing: -.5px;
        font: 400 32px 'Noto Sans KR', sans-serif;
    }

    .find-pw {
        width: 100%;
        max-width: 500px;
        padding: 50px 55px;
        position: relative;
        background-color: #fff;
        border: 1px solid #eee;
        box-sizing: border-box;
        margin: 70px auto 35px;
    }

    .find-pw h2 {
        margin-bottom: 50px;
        font: 400 18px 'Noto Sans KR', sans-serif;
    }
    .find-pw .guide {
        color: #fc326c;
        margin-bottom: 60px;
        letter-spacing: -1px;
        font: 400 15px/24px 'Noto Sans KR', sans-serif;
    }

    .find-pw li {margin-bottom: 10px;}

    .find-pw input {
        color: #b1b1b1;
        width: 100%;
        height: 50px;
        padding: 0 20px;
        border: 1px solid #d2d2d2;
        box-sizing: border-box;
        font: 400 16px 'Noto Sans KR', sans-serif;
    }

    .find-pw input::placeholder {color: #b1b1b1;}

    .pw-notice {
        color: #a9a9a9;
        margin-top: 15px;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .btn-ok {
        width: 120px;
        height: 50px;
        margin: 70px auto 0;
        background-color: #746ce6;
    }

    .btn-ok button {
        width: 100%;
        height: 100%;
        border: none;
        color: #fff;
        padding: 0;
        box-sizing: border-box;
        background-color: transparent;
        font: 400 16px/50px 'Noto Sans KR', sans-serif;
    }
</style>